<template>
  <button
    type="button"
    class="newsletter-export-button"
    title="Exporter les statistiques newsletter du mois précédent"
    :disabled="isExporting"
    @click="exportCsv"
  >
    <i v-if="!isExporting" class="fas fa-download" aria-hidden="true" />
    <span v-else class="newsletter-export-spinner" aria-hidden="true" />
    <span>{{ isExporting ? 'Export en cours...' : 'Export newsletter' }}</span>
  </button>
</template>

<script>
import { http } from '@/services/api.service'

export default {
  name: 'NewsletterClientStatsExportButton',
  data () {
    return {
      isExporting: false
    }
  },
  methods: {
    exportCsv () {
      if (this.isExporting) {
        return
      }

      this.isExporting = true
      http.get('/dashboard/newsletter-client-stats-export', { responseType: 'blob' })
        .then(response => {
          const filename = this.extractFilename(response.headers?.['content-disposition'])
          this.downloadBlob(response.data, filename)
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: 'Impossible de générer l’export newsletter.',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isExporting = false
        })
    },
    extractFilename (contentDisposition) {
      const fallback = 'newsletter-client-stats.csv'
      if (!contentDisposition) {
        return fallback
      }

      const match = contentDisposition.match(/filename="?([^";]+)"?/)
      return match?.[1] || fallback
    },
    downloadBlob (blob, filename) {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.newsletter-export-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.5rem;
  background: #2563eb;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1;
  padding: 0.75rem 1rem;
  white-space: nowrap;
}

.newsletter-export-button:hover:not(:disabled) {
  background: #1d4ed8;
}

.newsletter-export-button:disabled {
  cursor: wait;
  opacity: 0.65;
}

.newsletter-export-spinner {
  width: 0.875rem;
  height: 0.875rem;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #ffffff;
  border-radius: 9999px;
  animation: newsletter-export-spin 0.7s linear infinite;
}

@keyframes newsletter-export-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
